<template>
  <div class="box">
    <v-app id="app-secretaria-grafico-hemoglobina-glicada">
      <v-carousel
        :height="tela"
        class="carousel"
        @change="carrega"
        v-model="model"
      >
        <v-carousel-item>
          <pulse-loader
            :loading="loading"
            color="#26b2e3"
            size="25px"
            class="vue-loader"
          ></pulse-loader>
          <v-sheet height="1000" tile>
            <div class="box-header">
              <h4 class="box-title">Município</h4>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-lg-8">
                  <apexchart
                    type="bar"
                    height="350"
                    :options="municipioBarOptions"
                    :series="chartDataBarMunicipio"
                    ref="chartDataBarMunicipio"
                  ></apexchart>
                </div>
                <div class="col-lg-4 flex-column">
                  <div class="row">
                    <div class="col-12">
                      <apexchart
                        type="radialBar"
                        height="200"
                        :options="municipioCircleOptions"
                        :series="chartDataCircleMunicipio"
                        ref="chartDataCircleMunicipio"
                      ></apexchart>
                    </div>
                  </div>
                  <div class="row">
                    <div class="c-container-info col-12">
                      <div class="info-evolucao">
                        <div
                          v-if="arrayChartMunicipioComputed == 0"
                          class="evolucao laranja"
                        >
                          {{ arrayChartMunicipioComputed }}
                        </div>
                        <div
                          v-else-if="arrayChartMunicipioComputed > 0"
                          class="evolucao verde"
                        >
                          {{ `+ ${arrayChartMunicipioComputed}` }}
                        </div>

                        <div
                          v-else-if="arrayChartMunicipioComputed < 0"
                          class="evolucao vermelho"
                        >
                          {{ arrayChartMunicipioComputed }}
                        </div>
                        <span>
                          <i
                            v-b-tooltip.hover
                            title="Diferença entre o resultado do mês anterior e o mês atual"
                            class="icon-tooltip icofont-info-circle"
                          ></i>
                        </span>
                      </div>
                      <div class="rostinho">
                        <i
                          v-if="arrayChartMunicipioComputed == 0"
                          class="icofont-sad"
                        ></i>
                        <i
                          v-if="arrayChartMunicipioComputed > 0"
                          class="icofont-heart-eyes"
                        ></i>
                        <i
                          v-if="arrayChartMunicipioComputed < 0"
                          class="icofont-crying"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-sheet>
        </v-carousel-item>
        <v-carousel-item v-if="temEquipe">
          <pulse-loader
            :loading="loading"
            color="#26b2e3"
            size="25px"
            class="vue-loader"
          ></pulse-loader>
          <v-sheet height="100%" tile>
            <div class="box-header">
              <h4 class="box-title">Equipe</h4>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-lg-8">
                  <apexchart
                    type="bar"
                    height="350"
                    :options="equipeBarOptions"
                    :series="chartDataBarEquipe"
                    ref="chartDataBarEquipe"
                  ></apexchart>
                </div>
                <div class="col-lg-4 flex-column">
                  <div class="row">
                    <div class="col-12">
                      <apexchart
                        type="radialBar"
                        height="200"
                        :options="equipeCircleOptions"
                        :series="chartDataCircleEquipe"
                        ref="chartDataCircleEquipe"
                      ></apexchart>
                    </div>
                  </div>
                  <div class="row">
                    <div class="c-container-info col-12">
                      <div class="info-evolucao">
                        <div
                          v-if="arrayChartEquipeComputed == 0"
                          class="evolucao laranja"
                        >
                          {{ arrayChartEquipeComputed }}
                        </div>
                        <div
                          v-else-if="arrayChartEquipeComputed > 0"
                          class="evolucao verde"
                        >
                          {{ `+ ${arrayChartEquipeComputed}` }}
                        </div>

                        <div
                          v-else-if="arrayChartEquipeComputed < 0"
                          class="evolucao vermelho"
                        >
                          {{ arrayChartEquipeComputed }}
                        </div>
                        <span>
                          <i
                            v-b-tooltip.hover
                            title="Diferença entre o resultado do mês anterior e o mês atual"
                            class="icon-tooltip icofont-info-circle"
                          ></i>
                        </span>
                      </div>
                      <div class="rostinho">
                        <i
                          v-if="arrayChartEquipeComputed == 0"
                          class="icofont-sad"
                        ></i>
                        <i
                          v-if="arrayChartEquipeComputed > 0"
                          class="icofont-heart-eyes"
                        ></i>
                        <i
                          v-if="arrayChartEquipeComputed < 0"
                          class="icofont-crying"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-sheet>
        </v-carousel-item>
        <v-carousel-item v-if="temAcs">
          <pulse-loader
            :loading="loading"
            color="#26b2e3"
            size="25px"
            class="vue-loader"
          ></pulse-loader>
          <v-sheet height="100%" tile>
            <div class="box-header">
              <h4 class="box-title">Micro área</h4>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-lg-8">
                  <apexchart
                    type="bar"
                    height="350"
                    :options="acsBarOptions"
                    :series="chartDataBarAcs"
                    ref="chartDataBarAcs"
                  ></apexchart>
                </div>
                <div class="col-lg-4 flex-column">
                  <div class="row">
                    <div class="col-12">
                      <apexchart
                        type="radialBar"
                        height="200"
                        :options="acsCircleOptions"
                        :series="chartDataCircleAcs"
                        ref="chartDataCircleAcs"
                      ></apexchart>
                    </div>
                  </div>
                  <div class="row">
                    <div class="c-container-info col-12">
                      <div class="info-evolucao">
                        <div
                          v-if="arrayChartAcsComputed == 0"
                          class="evolucao laranja"
                        >
                          {{ arrayChartAcsComputed }}
                        </div>
                        <div
                          v-else-if="arrayChartAcsComputed > 0"
                          class="evolucao verde"
                        >
                          {{ `+ ${arrayChartAcsComputed}` }}
                        </div>

                        <div
                          v-else-if="arrayChartAcsComputed < 0"
                          class="evolucao vermelho"
                        >
                          {{ arrayChartAcsComputed }}
                        </div>
                        <span>
                          <i
                            v-b-tooltip.hover
                            title="Diferença entre o resultado do mês anterior e o mês atual"
                            class="icon-tooltip icofont-info-circle"
                          ></i>
                        </span>
                      </div>
                      <div class="rostinho">
                        <i
                          v-if="arrayChartAcsComputed == 0"
                          class="icofont-sad"
                        ></i>
                        <i
                          v-if="arrayChartAcsComputed > 0"
                          class="icofont-heart-eyes"
                        ></i>
                        <i
                          v-if="arrayChartAcsComputed < 0"
                          class="icofont-crying"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </v-app>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import {
  municipioBarOptions,
  municipioCircleOptions,
  equipeBarOptions,
  equipeCircleOptions,
  acsBarOptions,
  acsCircleOptions,
} from './utils.js'
export default {
  name: 'SecretariaGrafico',
  components: {
    apexchart: VueApexCharts,
    PulseLoader,
  },
  props: {
    arrayChartMunicipio: {
      type: Array,
      default: [],
    },
    arrayChartEquipe: {
      type: Array,
      default: [],
    },
    arrayChartAcs: {
      type: Array,
      default: [],
    },
    temEquipe: {
      type: Boolean,
      default: false,
    },
    temAcs: {
      type: Boolean,
      default: false,
    },
    no_municipio_estimadas: {
      type: Number,
      default: 0,
    },
    no_municipio_informadas: {
      type: Number,
      default: 0,
    },
    no_municipio_numerador: {
      type: Number,
      default: 0,
    },
    no_municipio_resultado: {
      type: Number,
      default: 0,
    },
    na_equipe_estimadas: {
      type: Number,
      default: 0,
    },
    na_equipe_informadas: {
      type: Number,
      default: 0,
    },
    na_equipe_numerador: {
      type: Number,
      default: 0,
    },
    na_equipe_resultado: {
      type: Number,
      default: 0,
    },
    no_acs_informadas: {
      type: Number,
      default: 0,
    },
    no_acs_numerador: {
      type: Number,
      default: 0,
    },
    no_acs_resultado: {
      type: Number,
      default: 0,
    },
    no_municipio_cad_sisab: {
      type: Number,
      default: 0,
    },
    no_municipio_percent_cad_sisab: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      tela: '',
      carregouEquipe: false,
      carregouAcs: false,
      model: 0,
      colors: ['primary', 'secondary', 'yellow darken-2', 'red', 'orange'],
      dados: [],
      xaxis: [],

      // Municipio
      chartDataBarMunicipio: [],
      chartDataCircleMunicipio: [],
      municipioBarOptions: {
        ...municipioBarOptions,
      },
      municipioCircleOptions: {
        ...municipioCircleOptions,
      },

      // Equipe
      chartDataBarEquipe: [],
      chartDataCircleEquipe: [],

      equipeBarOptions: {
        ...equipeBarOptions,
      },
      equipeCircleOptions: {
        ...equipeCircleOptions,
      },

      // ACS
      chartDataBarAcs: [],
      chartDataCircleAcs: [],

      acsBarOptions: {
        ...acsBarOptions,
      },
      acsCircleOptions: {
        ...acsCircleOptions,
      },
    }
  },
  created() {
    if (window.innerWidth < 992) {
      this.tela = '1000'
    } else {
      this.tela = '500'
    }
  },
  async mounted() {
    this.carregouEquipe = false
    await this.carregarDados()
    await this.carregaGraficoMunicipio()
  },
  computed: {
    arrayChartMunicipioComputed() {
      const valorMesAtual =
        this.arrayChartMunicipio[this.arrayChartMunicipio.length - 1]
      const valorMesAnterior =
        this.arrayChartMunicipio[this.arrayChartMunicipio.length - 2]
      const valor = valorMesAtual - valorMesAnterior

      return valor
    },
    arrayChartEquipeComputed() {
      const valorMesAtual =
        this.arrayChartEquipe[this.arrayChartEquipe.length - 1]
      const valorMesAnterior =
        this.arrayChartEquipe[this.arrayChartEquipe.length - 2]
      const valor = valorMesAtual - valorMesAnterior

      return valor
    },
    arrayChartAcsComputed() {
      const valorMesAtual = this.arrayChartAcs[this.arrayChartAcs.length - 1]
      const valorMesAnterior = this.arrayChartAcs[this.arrayChartAcs.length - 2]
      const valor = valorMesAtual - valorMesAnterior

      return valor
    },
  },
  methods: {
    calculoDeSemanasParaAcabarOQuadrimestre() {
      let data_inicio = null
      let data_fim = null
      let date = new Date()
      let mes_atual = date.getMonth() + 1
      let ano_atual = date.getFullYear()
      let data_atual = null

      // Pega a data atual
      data_atual = new Date()
        .toLocaleDateString('pt-BR')
        .split('/')
        .reverse()
        .join('-')

      // Pega o inicio e fim do quadrimestre
      if (mes_atual >= 1 && mes_atual <= 4) {
        data_inicio = `${ano_atual}-01-01`
        data_fim = `${ano_atual}-04-30`
      } else if (mes_atual >= 5 && mes_atual <= 8) {
        data_inicio = `${ano_atual}-05-01`
        data_fim = `${ano_atual}-08-31`
      } else if (mes_atual >= 9 && mes_atual <= 12) {
        data_inicio = `${ano_atual}-09-01`
        data_fim = `${ano_atual}-12-31`
      } else {
        data_inicio = ''
        data_fim = ''
      }

      const data_milisegundos = new Date(data_fim) - new Date(data_atual)
      const data_em_dias = data_milisegundos / (1000 * 60 * 60 * 24)
      const dias_que_faltam = data_em_dias + 1

      let semanas_que_faltam = Math.ceil(dias_que_faltam / 7)
      return semanas_que_faltam
    },
    async carregarDados() {
      this.dados.push({
        tipo: 'municipio',
        estimadas: this.no_municipio_estimadas,
        informadas: this.no_municipio_informadas,
        numerador: this.no_municipio_numerador,
        resultado: this.no_municipio_resultado,
      })
      if (this.temEquipe) {
        this.dados.push({
          tipo: 'equipe',
          estimadas: this.na_equipe_estimadas,
          informadas: this.na_equipe_informadas,
          numerador: this.na_equipe_numerador,
          resultado: this.na_equipe_resultado,
        })
      }
      if (this.temAcs) {
        this.dados.push({
          tipo: 'acs',

          informadas: this.no_acs_informadas,
          numerador: this.no_acs_numerador,
          resultado: this.no_acs_resultado,
        })
      }
    },
    async carregaGraficoMunicipio() {
      this.loading = true
      let array_xaxis = []
      const cadastrosEEstimativa =
        (this.no_municipio_informadas / this.no_municipio_estimadas) * 100
      let denominadorUtilizado = null
      if (this.no_municipio_percent_cad_sisab < 85) {
        denominadorUtilizado = this.no_municipio_estimadas
      } else if (this.no_municipio_cad_sisab > this.no_municipio_informadas) {
        denominadorUtilizado = this.no_municipio_cad_sisab
      } else {
        denominadorUtilizado = this.no_municipio_informadas
      }
      
      /*  if (cadastrosEEstimativa >= 85) {
        denominadorUtilizado = this.no_municipio_informadas
      } else {
        denominadorUtilizado = this.no_municipio_estimadas
      } */
      const semanas_que_faltam = this.calculoDeSemanasParaAcabarOQuadrimestre()

      const pessoas_que_faltam_ser_acompanhadas =
        this.no_municipio_informadas - this.no_municipio_numerador
      const meta_semanal =
        (pessoas_que_faltam_ser_acompanhadas / semanas_que_faltam) * 0.4
      const meta_quadrimestral = 50
      array_xaxis.push(
        this.no_municipio_estimadas,
        this.no_municipio_percent_cad_sisab,
        this.no_municipio_informadas,
        this.no_municipio_cad_sisab,
        this.no_municipio_numerador,
        denominadorUtilizado,
        pessoas_que_faltam_ser_acompanhadas,
        meta_quadrimestral,
        Math.trunc(meta_semanal)
      )

      const max = Math.max(
        this.no_municipio_estimadas,
        this.no_municipio_informadas,
        meta_quadrimestral
      )

      setTimeout(() => {
        this.$refs.chartDataBarMunicipio.updateOptions({
          yaxis: {
            max: max,
          },
        })
        this.$refs.chartDataBarMunicipio.updateSeries([
          { name: 'Valor', data: array_xaxis },
        ])

        // -------------------------------
        this.chartDataCircleMunicipio.push(this.no_municipio_resultado)
        this.loading = false
      }, 1000)
    },
    async carregaGraficoEquipe() {
      this.loading = true
      let array_xaxis = []

      const semanas_que_faltam = this.calculoDeSemanasParaAcabarOQuadrimestre()

      const pessoas_que_faltam_ser_acompanhadas =
        this.na_equipe_informadas - this.na_equipe_numerador
      const meta_semanal =
        (pessoas_que_faltam_ser_acompanhadas / semanas_que_faltam) * 0.4
      const meta_quadrimestral = 50
      array_xaxis.push(
        this.na_equipe_informadas,
        this.na_equipe_numerador,
        pessoas_que_faltam_ser_acompanhadas,
        meta_quadrimestral,
        Math.trunc(meta_semanal)
      )
      const max = Math.max(this.na_equipe_informadas, meta_quadrimestral)
      setTimeout(() => {
        this.$refs.chartDataBarEquipe.updateOptions({
          yaxis: {
            max: max,
          },
        })
        this.$refs.chartDataBarEquipe.updateSeries([
          { name: 'Valor', data: array_xaxis },
        ])

        // -------------------------------
        this.chartDataCircleEquipe.push(this.na_equipe_resultado)
        this.loading = false
      }, 1000)
    },
    async carregaGraficoAcs() {
      this.loading = true
      let array_xaxis = []

      const semanas_que_faltam = this.calculoDeSemanasParaAcabarOQuadrimestre()

      const pessoas_que_faltam_ser_acompanhadas =
        this.no_acs_informadas - this.no_acs_numerador
      const meta_semanal =
        (pessoas_que_faltam_ser_acompanhadas / semanas_que_faltam) * 0.4
      const meta_quadrimestral = 50
      array_xaxis.push(
        this.no_acs_informadas,
        this.no_acs_numerador,
        pessoas_que_faltam_ser_acompanhadas,
        meta_quadrimestral,
        Math.trunc(meta_semanal)
      )

      const max = Math.max(this.no_acs_informadas, meta_quadrimestral)
      setTimeout(() => {
        this.$refs.chartDataBarAcs.updateOptions({
          yaxis: {
            max: max,
          },
        })
        this.$refs.chartDataBarAcs.updateSeries([
          { name: 'Valor', data: array_xaxis },
        ])

        // -------------------------------
        this.chartDataCircleAcs.push(this.no_acs_resultado)
        this.loading = false
      }, 1000)
    },
    async carrega() {
      if (this.model === 0) {
      }
      if (this.model === 1) {
        if (this.carregouEquipe === false) {
          this.carregouEquipe = true
          await this.carregaGraficoEquipe()
        }
      }
      if (this.model === 2) {
        if (this.carregouAcs === false) {
          this.carregouAcs = true
          await this.carregaGraficoAcs()
        }
      }
    },
  },
}
</script>

<style scoped>
.box {
  overflow-x: unset;
}
.c-container-info {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.c-container-info .info-evolucao {
  display: flex;
  gap: 2px;
  margin-left: 15px;
}
.c-container-info .info-evolucao span {
  display: flex;
}
.c-container-info .evolucao {
  border-radius: 10px;
  padding: 6px 12px;
  font-weight: bold;
  display: flex;
  min-width: 70px;
  max-width: 70px;
  justify-content: center;
}
.verde {
  border: 2px solid #93c174;
  color: #00b050;
}
.laranja {
  border: 2px solid #ffa500;
  color: #ffa500;
}
.vermelho {
  border: 2px solid #ff0000;
  color: #ff0000;
}

.c-container-info .rostinho {
  margin: 14px;
}

.c-container-info .rostinho .icofont-heart-eyes {
  color: #00b050;
  font-size: 45px;
}
.c-container-info .rostinho .icofont-sad {
  color: #ffa500;
  font-size: 45px;
}
.c-container-info .rostinho .icofont-crying {
  color: red;
  font-size: 45px;
}
</style>
<style lang="scss">
#app-secretaria-grafico-hemoglobina-glicada {
  .v-application--wrap {
    min-height: unset;
  }
}

#app-secretaria-grafico-hemoglobina-glicada .v-carousel__controls {
  background: white;
}
#app-secretaria-grafico-hemoglobina-glicada .v-item-group button {
  color: #b2b2b2;
}
#app-secretaria-grafico-hemoglobina-glicada .mdi-chevron-left::before,
#app-secretaria-grafico-hemoglobina-glicada .mdi-chevron-left::after {
  color: white;
}
#app-secretaria-grafico-hemoglobina-glicada .mdi-chevron-right::before,
#app-secretaria-grafico-hemoglobina-glicada .mdi-chevron-right::after {
  color: white;
}

@media screen and (max-width: 920px) {
  #app-secretaria-grafico-hemoglobina-glicada .carousel {
    height: 900px !important;
  }
}
</style>
<style scoped>
#app-secretaria-grafico-hemoglobina-glicada .icon-tooltip {
  font-size: 14px;
}
</style>
